import {TWO_FACTOR_TYPE} from "./contants.js";

export const popItem = (props = {}) => {
    const {authType = TWO_FACTOR_TYPE.EMAIL_OR_CELLPHONE} = props;
    const isSelectType = authType === TWO_FACTOR_TYPE.EMAIL_OR_CELLPHONE;
    const LABEL = {
        step1: {
            title: i18next.t(login.twoFactor.title),
            desc1: i18next.t(login.twoFactor.desc),
            desc2: i18next.t(login.twoFactor.chooseOption),
        },
        step2: {
            title: i18next.t(common.inputValue, {val: $t(common.confirmVerificationCode)}),
            placeholder: i18next.t(main.alert.enterWord, {val: $t(common.confirmVerificationCode)}),
            unValidAuth: i18next.t(main.alert.verificationNotMatch),
            timeoutAuth: i18next.t(main.alert.verificationExpired),
            resendAuth: i18next.t(dictionary.resend),
            noneNumericAuth: i18next.t(common.enterDigitOnly),
        }
    };

    let title = `${LABEL.step1.title}`;
    let comment = `${LABEL.step1.desc1}<br>${LABEL.step1.desc2}`;

    let setTwofactorType = `
            <button class="phone js-two-factor-type" data-code="phone">
                    <svg width="17" height="16" fill="none" class="phone">
                        <rect width="11.444" height="15" x="2.778" y=".5" stroke="" rx="1.5"/>
                        <path stroke="" stroke-linecap="round" d="M6.333 12.882h4.334"/>
                        <circle cx="8.5" cy="3.441" r=".889" fill=""/>
                    </svg>
                    SMS
                </button>
            <button class="mail js-two-factor-type" data-code="mail">
                <svg width="16" height="16" fill="none">
                    <path fill="" fill-rule="evenodd" 
                        d="M0 4.255a2.478 2.478 0 0 1 2.478-2.478H13.5a2.5 2.5 0 0 1 2.5 2.5v7.445a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5V4.255Zm1 6.337V5.567l3.625 2.54L1 10.593Zm.002 1.21a1.5 1.5 0 0 0 1.498 1.42h11a1.5 1.5 0 0 0 1.495-1.37L10.38 8.72l-.7.497a3 3 0 0 1-3.458.01l-.723-.507-4.497 3.082ZM5.8 7.71l.997.699a2 2 0 0 0 2.305-.007l.98-.695 4.91-3.594A1.5 1.5 0 0 0 13.5 2.778H2.478C1.662 2.778 1 3.439 1 4.255v.09l4.78 3.351a.51.51 0 0 1 .02.014ZM15 5.346l-3.758 2.75L15 10.648v-5.3Z" clip-rule="evenodd"/>
                </svg>
                E-MAIL
            </button>
    `;

    //기능키 불가
    if (ServerChecker.isKsfc) {
        setTwofactorType = `
            <button class="phone js-two-factor-type" data-code="phone">
                <svg width="17" height="16" fill="none" class="phone">
                    <rect width="11.444" height="15" x="2.778" y=".5" stroke="" rx="1.5"/>
                    <path stroke="" stroke-linecap="round" d="M6.333 12.882h4.334"/>
                    <circle cx="8.5" cy="3.441" r=".889" fill=""/>
                </svg>
                M-OTP
            </button>
            <button class="web js-two-factor-type" data-code="web">
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11 20.8086C15.9706 20.8086 20 16.7792 20 11.8086C20 6.83803 15.9706 2.80859 11 2.80859C6.02944 2.80859 2 6.83803 2 11.8086C2 16.7792 6.02944 20.8086 11 20.8086ZM11 21.8086C16.5228 21.8086 21 17.3314 21 11.8086C21 6.28575 16.5228 1.80859 11 1.80859C5.47715 1.80859 1 6.28575 1 11.8086C1 17.3314 5.47715 21.8086 11 21.8086Z" fill="black"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.228 18.4735C13.9633 16.8192 14.4436 14.4636 14.4436 11.8086C14.4436 9.15359 13.9633 6.79803 13.228 5.14366C12.8598 4.31522 12.4473 3.70671 12.0397 3.31884C11.6373 2.93588 11.2874 2.80859 10.9991 2.80859C10.7109 2.80859 10.361 2.93588 9.95854 3.31884C9.55097 3.70671 9.13844 4.31522 8.77025 5.14366C8.03497 6.79803 7.55469 9.15359 7.55469 11.8086C7.55469 14.4636 8.03497 16.8192 8.77025 18.4735C9.13844 19.302 9.55097 19.9105 9.95854 20.2983C10.361 20.6813 10.7109 20.8086 10.9991 20.8086C11.2874 20.8086 11.6373 20.6813 12.0397 20.2983C12.4473 19.9105 12.8598 19.302 13.228 18.4735ZM10.9991 21.8086C13.4537 21.8086 15.4436 17.3314 15.4436 11.8086C15.4436 6.28575 13.4537 1.80859 10.9991 1.80859C8.54453 1.80859 6.55469 6.28575 6.55469 11.8086C6.55469 17.3314 8.54453 21.8086 10.9991 21.8086Z" fill="black"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3327 8.97559H2.66602V7.97559H19.3327V8.97559Z" fill="black"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3327 15.6416H2.66602V14.6416H19.3327V15.6416Z" fill="black"/>
                </svg>
                W-OTP
            </button>
        `;

        title = i18next.t("ksfc.login.twofactor.title");
        comment = `${i18next.t("ksfc.login.twofactor.desc")}<br>${i18next.t("ksfc.login.twofactor.chooseOption")}`;
    }

    return `
        <div class="flow-all-background-1 back-area" tabindex="0">
            <div class="flow-project-make-1 back-area">
                <div class="flow-project-make-2 back-area contents">
                    <div class="auth-popup flow-login-popup flow-project-popup-6 step1" style="display: ${isSelectType ? 'block' : 'none'}">
                        <div class="flow-project-header-1">
                            <dt class="popup-title">${title}</dt>
                            <button class="btn-close close-event"></button>
                        </div>
                        <div class="flow-content">
                            <div class="login-number-wrap">
                                <p class="login-number">${comment}</p>
                            </div>
                            <div class="btn-wrap">
                                ${setTwofactorType}
                            </div>
                        </div>
                    </div>
                    <div class="auth-popup flow-login-popup flow-project-popup-6 step2" style="display: ${isSelectType ? 'none' : 'block'}">
                        <div class="flow-project-header-1">
                            <button class="btn-back" style="display: ${isSelectType ? 'block' : 'none'}"></button>
                            <dt class="popup-title">${LABEL.step2.title}</dt>
                            <button class="btn-close close-event"></button>
                        </div>
                        <div class="flow-content">
                            <div class="login-number-wrap">
                                <p class="login-number"><span class="popup-cont"></span></p>
                            </div>
                            <div class="login-input-wrap">
                                <input id="certNo" type="text" placeholder="${LABEL.step2.placeholder}"
                                       class="login-popup-input" maxlength="6" autocomplete="off">
                                <div class="login-text-count js-auth-counter"></div>
                            </div>                
                            <div class="auth-error-text">
                                <span id="unValidAuth" style="display : none">${LABEL.step2.unValidAuth}</span>
                                <span id="timeoutAuth" style="display : none">${LABEL.step2.timeoutAuth}</span>
                                <span id="resendAuth" class="resend-txt cursor-pointer" style="display : none">${LABEL.step2.resendAuth}</span>
                                <span id="noneNumericAuth" style="display : none">${LABEL.step2.noneNumericAuth}</span>
                            </div>
                            <a class="cursor-pointer">
                                <div class="confirm-button login-popup-button submit-event">${i18next.t(dictionary.confirm)}</div>
                            </a>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    `
}

